import React, { useState, useEffect } from "react";
import {
    Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button,
    IconButton, TextField, CircularProgress
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";
import { splitToSentences } from "../../../Utils/additionalInfo";

const NewSentencesWithMissingSection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const [inputText, setInputText] = useState("");

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, sentencesWithMissing: !expanded.sentencesWithMissing });
    };

    // When the text in the paste box changes, split it into sentences and create the newInfo
    useEffect(() => {
        const sentences = splitToSentences(inputText);
        additionalInfo.deleteAllNewInfo("sentencesWithMissing");
        if (sentences.length > 0) {
            additionalInfo.createWithData("sentencesWithMissing", sentences);
        }
    }, [inputText]);

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.sentencesWithMissing} onChange={() => handleToggle("sentencesWithMissing")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.sentencesWithMissing?.length || 0}) יצירת משפטים שחסר בהם מילה</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>

                    {/* תיבת הדבקה */}
                    <TextField
                        label="הדבק כאן טקסט עם משפטים"
                        multiline
                        fullWidth
                        minRows={3}
                        value={inputText}
                        onChange={(e) => setInputText(e.target.value)}
                        sx={{ mb: 2 }}
                        inputProps={{ dir: "auto" }}
                        placeholder={`1. This is the first sentence.
2. This is the second sentence.
Third sentence`}
                    />

                    {/* כפתורים: יצירה, שמירה, מחיקה */}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("sentencesWithMissing")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.sentencesWithMissing}
                    >
                        {loading.create.sentencesWithMissing ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.addAllExistsInfo("sentencesWithMissing")}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={additionalInfo.loading.addAllExistsInfo.sentencesWithMissing || newInfo.sentencesWithMissing?.length === 0}
                    >
                        {additionalInfo.loading.addAllExistsInfo.sentencesWithMissing ? <CircularProgress size={24} /> : "שמור הכל"}
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={async () => {
                            const _id = additionalInfo.existsInfo._id;
                            if (!_id) return;

                            await additionalInfo.clearExistsInfoField(_id, "sentencesWithMissing");
                            await additionalInfo.addAllExistsInfo("sentencesWithMissing");
                        }}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={additionalInfo.loading.addAllExistsInfo.sentencesWithMissing || newInfo.sentencesWithMissing?.length === 0}
                    >
                        {additionalInfo.loading.addAllExistsInfo.sentencesWithMissing
                            ? <CircularProgress size={24} />
                            : "דרוס ושמור"}
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => additionalInfo.deleteAllNewInfo("sentencesWithMissing")}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={newInfo.sentencesWithMissing?.length === 0}
                    >
                        מחק הכל
                    </Button>

                    {/* תצוגת משפטים שנוצרו */}
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            justifyContent: "flex-start",
                            alignItems: "flex-start"
                        }}
                    >
                        {newInfo.sentencesWithMissing?.length > 0 ? (
                            newInfo.sentencesWithMissing.map((sentence, index) =>
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        bgcolor: "#f0f0f0",
                                        p: 1,
                                        borderRadius: 2,
                                        maxWidth: "210px",
                                        minWidth: "100px",
                                        flex: "1 0 auto"
                                    }}
                                >
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={sentence}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("sentencesWithMissing", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { sentencesMissing: sentence },
                                                    field: "sentencesWithMissing",
                                                    index,
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.sentencesWithMissing?.[index]}
                                        >
                                            {sentence && (additionalInfo.loading.addExistsInfo.sentencesWithMissing?.[index]
                                                ? <CircularProgress size={24} />
                                                : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("sentencesWithMissing", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={sentence}
                                        onChange={(e) => additionalInfo.editNewInfo("sentencesWithMissing", index, e.target.value)}
                                        sx={{
                                            direction: /^[\u0590-\u05FF]/.test(sentence) ? "ltr" : "rtl",
                                            flexGrow: 1
                                        }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Typography variant="body2" color="textSecondary">לא נוצרו משפטים שחסר בהם מילה</Typography>
                            </Box>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewSentencesWithMissingSection;
